import { useMemo } from 'react';
import { useGridStore, useAllProjects, useAllTasks } from '../state';
import type { VirtualRow } from '../types';

export const DEFAULT_ROW_HEIGHT = 37;
export const PROJECT_ROW_HEIGHT = 48;

export function useVirtualRows(): VirtualRow[] {
    const projects = useAllProjects();
    const tasks = useAllTasks();
    const expandedProjectIds = useGridStore(state => state.expandedProjectIds);

    return useMemo(() => {
        const rows: VirtualRow[] = [];
        let isFirstProject = true;

        // Build minimal row identifiers
        for (const project of projects) {
            const projectTasks = tasks.filter(t => t.projectId === project.id);
            const isExpanded = expandedProjectIds.has(project.id);

            // Add spacer before each project row (except the first)
            if (!isFirstProject) {
                rows.push({
                    type: 'spacer',
                    height: 8,
                });
            }
            isFirstProject = false;

            // Add project row identifier
            rows.push({
                type: 'project',
                projectId: project.id,
                height: PROJECT_ROW_HEIGHT,
            });

            // Add task row identifiers if expanded
            if (isExpanded) {
                for (const task of projectTasks) {
                    rows.push({
                        type: 'task',
                        taskId: task.id,
                        projectId: project.id,
                        workType: task.workType || 'default',
                        height: DEFAULT_ROW_HEIGHT,
                    });
                }
            }
        }
        rows.push(
            // Add spacer before total row
            {
                type: 'spacer',
                height: 8,
            },
        );

        return rows;
    }, [projects, tasks, expandedProjectIds]);
}
